export default import.meta.ROLLDOWN_FILE_URL_2Sl7HlMhijdUUph45mXJlg